export const STEPS = {
	LOAD: 'LOAD',
	FINISH: 'FINISH',
};
